import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

/* Hosts where, with REACT_APP_PREVIEW_AUTH_BYPASS=true, the login screen is
   skipped and a dummy user is used instead. Gated on hostname so this can
   never activate on the live Netlify domain even if the env var leaks there. */
const PREVIEW_BYPASS_HOSTS = ["commander-workbench.preview.emergentagent.com", "localhost"];

export function isPreviewAuthBypassActive() {
  return (
    PREVIEW_BYPASS_HOSTS.includes(window.location.hostname) &&
    process.env.REACT_APP_PREVIEW_AUTH_BYPASS === "true"
  );
}

export const firebaseApp = getApps()[0] || initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
